export default __webpack_public_path__ + "static/media/create_24px.1f3c88a1.svg";